import classes from "./ResetFiltersBtn.module.css";

export function ResetFiltersBtn({ disabled, onClick, text }) {
  return (
    <button className={classes.resetBtn} disabled={disabled} onClick={onClick}>
      {text}
    </button>
  );
}
